import { useEffect, useState, useRef } from 'react';
import { useIntersection } from '@buzzfeed/react-components';
import { trackClientImpression } from '../analytics/client-event-tracking';

export function useContentGating(buzz, isContentGate) {
  const contentGateRef = useRef(null);
  const [isGate, setIsGate] = useState(false);
  const { isIntersecting, setObservable } = useIntersection({
    once: true,
    threshold: 0.1,
    pageId: 'content_gate',
    defaultValue: isGate
  });

  useEffect(() => {
    const isGating = buzz.bfpFormats.includes('content_gate') && isContentGate;
    if (isGating && !buzz.disableAds) {
      setIsGate(isGating);
    }

  }, [buzz, isContentGate]);

  useEffect(() => {
    if (isIntersecting && contentGateRef?.current && isGate) {
      const contentGate = contentGateRef?.current.querySelector('.subbuzz-bfp--content_gate');
      if (contentGate) {
        const mobileAppPromo = document.getElementById('mobile-app-promo');
        if (mobileAppPromo) {
          mobileAppPromo.style.zIndex = '497';
        }
        document.documentElement.style.overflow = 'hidden';
        document.body.classList.add('content-gate-open');
        contentGate.classList.add('isActive');
        trackClientImpression(buzz, {
          target_content_id: 'membership_products',
          target_content_type: 'utility',
          unit_name: 'membership_gate',
          unit_type: 'modal',
          item_name: 'get_started',
          item_type: 'button'
        });
      }
    }
  }, [isIntersecting, isGate, contentGateRef])

  return { contentGateRef, gateObservable: isGate ? setObservable : null};
}
